// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","services":"_3aHkPy8CjaiP","services_horizontal":"JPf1ArXtBFVT"};